export default function() {
    document.addEventListener('DOMContentLoaded', function () {
        var cprSearchInterface = document.querySelectorAll('.CoveoSearchInterface');
        var cSearch = cprSearchInterface[cprSearchInterface.length - 1];
        if(window.Coveo && cSearch && typeof window.Coveo !== 'undefined') {
            setTimeout(() => {
                // Coveo dropdown
                window.VJSDropdown.destroy();
                window.VJSDropdown.init();
                window.Coveo.$$(cSearch).on('newResultsDisplayed', function(e, args) {
                    window.VJSDropdown.destroy();
                    window.VJSDropdown.init();
                });
            }, 1000);
        }
    });
}



// WEBPACK FOOTER //
// ./src/app/utils/vjs-dropdown-coveo.js